window.addEventListener('message', function messageHandler(e) {
  if (e.data === 'aoflReady') {
    require('./cdiv-page/cdiv-page.html');
    window.removeEventListener('message', messageHandler);
  }
});



// WEBPACK FOOTER //
// ./cdiv/en-US/js/main.js